import { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { Leaf, MapPin, Sparkles } from "lucide-react";
import { motion, AnimatePresence } from "framer-motion";

const CAT_LABEL = {
  forestry: "forestry", renewable: "renewables", ocean: "blue-carbon",
  agriculture: "regen-ag", direct_air: "direct air capture",
};

export default function ImpactFeed() {
  const [feed, setFeed] = useState([]);

  const load = () => api.get("/feed").then((r) => setFeed(r.data)).catch(() => {});

  useEffect(() => {
    load();
    const t = setInterval(load, 30_000);
    return () => clearInterval(t);
  }, []);

  if (feed.length === 0) return null;

  return (
    <section className="border-t border-stone-200/80 bg-[#FAFAF9]">
      <div className="max-w-7xl mx-auto px-6 py-20">
        <div className="flex items-end justify-between mb-8">
          <div>
            <div className="text-xs uppercase tracking-[0.2em] font-semibold text-stone-500 flex items-center gap-2">
              <Sparkles className="w-3.5 h-3.5 text-[#D97757]"/> Live impact feed
            </div>
            <h2 className="text-3xl sm:text-4xl tracking-tight font-medium mt-2">Retirements happening right now</h2>
          </div>
          <div className="hidden sm:flex items-center gap-2 text-xs text-stone-500">
            <span className="relative flex h-2 w-2">
              <span className="animate-ping absolute inline-flex h-full w-full rounded-full bg-emerald-400 opacity-75"></span>
              <span className="relative inline-flex rounded-full h-2 w-2 bg-emerald-500"></span>
            </span>
            Live · updates every 30s
          </div>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-3">
          <AnimatePresence>
            {feed.slice(0, 9).map((f) => (
              <motion.div
                key={f.id}
                data-testid={`feed-item-${f.id}`}
                initial={{ opacity: 0, y: 10 }}
                animate={{ opacity: 1, y: 0 }}
                exit={{ opacity: 0 }}
                transition={{ duration: 0.35 }}
                className="p-4 bg-white border border-stone-200 rounded-2xl flex items-start gap-3"
              >
                <div className="w-9 h-9 rounded-xl bg-[#2C5530]/10 flex items-center justify-center flex-shrink-0">
                  <Leaf className="w-4 h-4 text-[#2C5530]"/>
                </div>
                <div className="flex-1 min-w-0">
                  <div className="text-sm leading-snug">
                    {f.anonymous ? (
                      <span className="text-stone-600">An <span className="font-medium text-[#1C1917]">anonymous buyer</span></span>
                    ) : (
                      <span className="text-stone-600"><span className="font-medium text-[#1C1917]">{f.industry || "A company"}{f.country ? ` from ${f.country}` : ""}</span></span>
                    )}
                    <span className="text-stone-600"> retired </span>
                    <span className="font-medium text-[#2C5530]">{f.tons.toLocaleString()}t</span>
                    <span className="text-stone-600"> of {CAT_LABEL[f.category] || f.category}</span>
                  </div>
                  <div className="text-xs text-stone-500 mt-1.5 flex items-center gap-2">
                    {f.project_location && <span className="flex items-center gap-1"><MapPin className="w-3 h-3"/>{f.project_location}</span>}
                    <span>· {f.when}</span>
                  </div>
                </div>
              </motion.div>
            ))}
          </AnimatePresence>
        </div>
      </div>
    </section>
  );
}
